// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__R3CoQ","overflowing":"ReadFullNote_overflowing__3xCHy"};